// extracted by mini-css-extract-plugin
export default {"border":"D4hvC","a11yFocus":"_131l1","a11YFocus":"_131l1","submitButton":"yabXH","title":"c6Nh2","subtitle":"_325-Q"};